"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamoDBTable = exports.LambdaFunction = void 0;
const AWSCommon_1 = require("./AWSCommon");
class LambdaFunction extends AWSCommon_1.AWSCommon {
    constructor({ ...ob }) {
        super(ob);
        /** not required if arn is correct, retained to show can be used if some arns are deviant */
        this.type = 'LambdaFunction';
    }
}
exports.LambdaFunction = LambdaFunction;
class DynamoDBTable extends AWSCommon_1.AWSCommon {
    constructor({ ...ob }) {
        super(ob);
    }
}
exports.DynamoDBTable = DynamoDBTable;
